import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';
import { fetchEmployees } from '../../store/actions/employee';
import { requestPhotoReport } from '../../store/actions/report';
import Fingerprint from '@material-ui/icons/Fingerprint';
import AddIcon from '@material-ui/icons/Add';
import Select from 'react-select';
import axios from '../../config/axiosInstance';
import CreateLocation from '../Locations/CreateLocation';

const styles = theme => ({
    container: {
        padding: `0 ${theme.spacing(3)}px`,
    },
    paperWidth: {
        width: '80%',
        height: '80%',
    },
});

class Devices extends React.Component {
    state = {
        modal: false,
        opstions: [],
        selectedOption: '',
        modalLocal: false,
        devices: [],
        itemSelected: [],
        itemSelectedModal: '',
        snackbarAlert: false,
        associationModal: false,
        disabled: true,
        row: []
    };

    componentDidMount() {
        this.props.onFetchEmployees();
        this.fetchEvent();
        // this.fetchDevices();
        this.fetchNameDevice();
    }

    modalRender = (item) => {
        this.fetchDevices(item.deviceId);
        this.setState({ modal: true, itemSelectedModal: item.name });
    };

    addListDevices = (item) => {
        if (this.state.itemSelected.filter(i => i == item).length > 0) {
            this.setState({ snackbarAlert: true })
        } else {
            this.state.itemSelected.push(item)
            this.setState({ disabled: false })
        }
    };

    fetchEvent = () => {
        axios.get('/location')
            .then((result) => {
                this.setState({ opstions: result.data })
            })
            .catch(error => console.log('error', error));
    }

    fetchNameDevice = () => {
        axios.get('/device/allNames')
            .then((result) => {
                this.setState({ devices: result.data[0] })
            })
            .catch(error => console.log('error', error));
    }

    fetchDevices = (uuid) => {
        axios.get(`/device/${uuid}`)
            .then((result) => {
                this.setState({ row: result.data[0] })
            })
            .catch(error => console.log('error', error));
    }

    associationDevices = () => {
        axios.put('/device/update', {
            devicesId: this.state.itemSelected,
            locationId: this.state.selectedOption.id,
            lat: this.state.selectedOption.lat,
            lng: this.state.selectedOption.lng,
            name: this.state.selectedOption.description
        })
            .then((result) => {
                this.setState({ associationModal: false });
                this.setState({ itemSelected: [] });
                this.setState({ disabled: true });
                this.fetchDevices();
            })
            .catch(error => console.log('error', error));
    };

    render() {
        const { classes, loading } = this.props;
        const { devices, itemSelected } = this.state;

        const columns = [
            { name: 'deviceId', label: 'ID do Aparelho' },
            { name: 'deviceName', label: 'Local do Aparelho' },
        ];

        const modalColumns = [
            { name: 'name', label: 'Nome' },
            { name: 'dtRegister', label: 'Dia' },
            { name: 'timeRegister', label: 'Hora' },
            { name: 'type', label: 'Tipo' },
        ];

        const actions = [
            // {
            //     name: 'Pontos Neste Dispositivo',
            //     icon: Fingerprint,
            //     onClick: item => this.modalRender(item)
            // },
            {
                name: 'Adicionar Dispositivo a Lista',
                icon: AddIcon,
                onClick: item => this.addListDevices(item.deviceId)
            },
        ];

        const actionsCheck = [
            {
                name: 'Pontos Neste Dispositivo',
                icon: Fingerprint,
                onClick: item => this.modalRender(item)
            },
        ];

        const options = this.state.opstions?.map((i) => {
            i.value = i.id;
            i.label = i.description;
            return i;
        });


        return (
            <React.Fragment>
                <ContentHeader
                    title="Lista de Dispositivos"
                    subtitle="Associe os dispositivos a um local"
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.setState({ associationModal: true })}
                        disabled={this.state.disabled}
                    >
                        Associar Dispositivos
                    </Button>

                </ContentHeader>

                <Paper elevation={2} style={{ padding: '20px' }}>
                    <DataTable
                        rows={devices}
                        actions={actions}
                        columns={columns}
                        loading={loading}
                    />
                </Paper>

                <Dialog
                    open={this.state.modal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Pontos deste dispositivo</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" color="#222">
                            <DataTable
                                rows={this.state.row.filter(i => i.deviceId == this.state.itemSelectedModal)?.map(i => i.timeclocks[0])[0]?.map(i => ({
                                    id: i.id,
                                    name: i.employee.name,
                                    dtRegister: (moment(i.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy')),
                                    timeRegister: (moment(i.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm')),
                                    type: i.dtRegister == 'I' ? 'Entrada' : 'Saída',
                                }))}
                                columns={modalColumns}
                                loading={loading}
                            />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ modal: false })} color="primary" autoFocus>Fechar</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.modalLocal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'80%'}
                    PaperProps={{ classes: { root: classes.paperWidth } }}
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" color="#222">
                            <CreateLocation />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.setState({ modalLocal: false }); this.fetchEvent(); }} color="primary" autoFocus>Fechar</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.associationModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'100%'}
                    PaperProps={{ classes: { root: classes.paperWidth } }}
                >
                    <DialogTitle id="alert-dialog-title">Dispositivo selecionados</DialogTitle>
                    <DialogContent>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '55%' }} data-tut="reactour__Select">
                                <Typography variant="body2" color="textPrimary" style={{ textAlign: 'start' }}>
                                    Escolha um local para associar.
                                </Typography>
                                <Select
                                    options={options}
                                    onChange={item => this.setState({ selectedOption: item })}
                                    placeholder="Busque um usúario"
                                />
                            </div>
                            <Button
                                onClick={() => this.setState({ modalLocal: true })}
                                variant="outlined"
                                color="primary"
                                style={{
                                    marginLeft: '10px',
                                    marginTop: '23px',
                                    borderRadius: '30px'
                                }}
                            >
                                <AddIcon />
                            </Button>
                        </div>
                        <DialogContentText id="alert-dialog-description" color="#222">
                            <DataTable
                                rows={devices.filter(i => itemSelected.includes(i.deviceId))}
                                columns={columns}
                                actions={actionsCheck}
                            />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ associationModal: false })} color="primary" autoFocus>Fechar</Button>
                        <Button onClick={() => this.setState({ itemSelected: [], associationModal: false, disabled: true })} color="primary" autoFocus>Limpar Lista</Button>
                        <Button
                            variant="contained"
                            onClick={this.associationDevices}
                            color="primary"
                            autoFocus
                            disabled={this.state.selectedOption ? false : true}
                        >
                            Associar
                        </Button>
                    </DialogActions>
                </Dialog>

                <div >
                    <Snackbar open={this.state.snackbarAlert} autoHideDuration={2000} onClose={() => this.setState({ snackbarAlert: false })}>
                        <Alert severity="warning">Este item já esta na lista!</Alert>
                    </Snackbar>
                </div>
            </React.Fragment >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.general.loading,
    employees: state.employee.employees,
});

const mapDispatchToProps = dispatch => ({
    onFetchEmployees: () => dispatch(fetchEmployees()),
    onRequestReport: report => dispatch(requestPhotoReport(report)),
});

Devices.propTypes = {
    classes: PropTypes.object.isRequired,
    onFetchEmployees: PropTypes.func.isRequired,
    onRequestReport: PropTypes.func.isRequired,
    employees: PropTypes.array.isRequired,
    loading: PropTypes.bool,
};

Devices.defaultProps = {
    loading: false,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(Devices));
